// ============================================================
// MANIC MEETER — i18n entry point
// ============================================================

import type { LocaleContent } from "./contract";
import { getLocale, type Locale } from "./locale";
import { de } from "./de";
import { en } from "./en";

const CONTENT: Record<Locale, LocaleContent> = { de, en };

/** Content for the language currently switched on. */
export function C(): LocaleContent {
  return CONTENT[getLocale()];
}

/** Content for a specific language — used by the switcher and by tests. */
export function forLocale(locale: Locale): LocaleContent {
  return CONTENT[locale];
}

export { getLocale, setLocale, onLocaleChange, otherLocale, LOCALES, resetLocaleForTests } from "./locale";
export type { Locale } from "./locale";
export type { LocaleContent, UiStrings } from "./contract";
